<template>
  <!--
    The view for the ApiError-component
  -->
  <component
    :is="`Error${errorId}`"
    :from-route="fromRoute"
  />
</template>

<script>
export default {
  name: "ApiError",
  components: {
    Error404: () => import("@/components/Base/Error404.vue"),
    Error503: () => import("@/components/Base/Error503.vue"),
  },
  props: {
    errorId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fromRoute: null,
    };
  },
  metaInfo() {
    return {
      title: this.$t("error"),
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setFromRoute(to, from);
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.setFromRoute(to, from);
    next();
  },
  methods: {
    setFromRoute(to, from) {
      if (to.query && to.query.from) {
        this.fromRoute = { path: to.query.from };
        return;
      }
      let storedFrom = null;
      try {
        storedFrom = window.sessionStorage.getItem("errorFromRoute");
      } catch (e) {
        storedFrom = null;
      }
      if (storedFrom) {
        this.fromRoute = { path: storedFrom };
        return;
      }
      this.fromRoute = from;
    },
  },
};
</script>
